import { jsx } from "react/jsx-runtime";
import { styled } from "@mui/material/styles";
import { LinearProgress } from "@biome-design-system/ui/LinearProgress";
import { useFilterWizardContext } from "./FilterWizardContext.js";
const WizardProgress = styled(LinearProgress, {
  name: "MuiFilterWizard",
  slot: "progress"
})(() => ({}));
const Progress = ({ label }) => {
  const { progress } = useFilterWizardContext();
  return /* @__PURE__ */ jsx(
    WizardProgress,
    {
      "data-testid": "filter-wizard-progress",
      id: "filter-wizard-progress",
      label: label?.(progress),
      value: progress,
      variant: "determinate"
    }
  );
};
export {
  Progress
};
